// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as NLOrderTollBreakupVm from "./vm-mapper/NLOrderTollBreakupVm.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Name"
            },
            accessor: (function (toll) {
                return {
                        TAG: /* Text */0,
                        _0: toll.name
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Amount"
              },
              accessor: (function (toll) {
                  return {
                          TAG: /* Text */0,
                          _0: toll.amount
                        };
                })
            },
            tl: /* [] */0
          }
        };
}

function NLOrderTollsBreakup(Props) {
  var order_fare = Props.order_fare;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var tolls = NLOrderTollBreakupVm.getVm(order_fare, currency);
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Tolls Breakup"
                    }, undefined, undefined, tolls ? React.createElement(TableComponent$Catalyst.make, {
                            columns: getTableColumnsSchema(undefined),
                            rowData: tolls,
                            className: "c-nlo-table"
                          }) : "No tolls exist", undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderTollsBreakup;

export {
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
